"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseColumn = require("./support/BaseColumn");
var _NumberField = _interopRequireDefault(require("../../../inputs/input/NumberField"));
var _jsxRuntime = require("react/jsx-runtime");
var NumberFieldWithState = function NumberFieldWithState(_ref) {
  var initialValue = _ref.initialValue,
    update = _ref.update,
    cellProps = _ref.cellProps;
  var onBlur = function onBlur(event) {
    var value = Number(event.target.value.trim().replace(/,/g, ''));
    update(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NumberField.default, {
    value: (0, _BaseColumn.getCellValue)(initialValue, cellProps),
    onBlur: onBlur,
    minimumFractionDigits: 0,
    maximumFractionDigits: 10
  });
};
var NumberInputColumn = function NumberInputColumn(_) {
  return null;
};
NumberInputColumn.toColumnDef = function (child) {
  var props = child.props;
  var accessorKey = props.accessorKey,
    onInputChange = props.onInputChange;
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props), {
    accessorKey: accessorKey,
    cell: function cell(cellProps) {
      var row = cellProps.row,
        cell = cellProps.cell;
      var initialValue = row.original[cell.column.id];

      //TODO: not yet compatible with nested data structures
      var update = function update(value) {
        var numericValue = Number(value);
        if (row.original[accessorKey] !== numericValue && onInputChange) {
          var updatedRow = _objectSpread({}, row.original, _defineProperty({}, accessorKey, numericValue));
          onInputChange(updatedRow, accessorKey);
        }
      };
      return (0, _BaseColumn.styledCell)(child.props, /*#__PURE__*/(0, _jsxRuntime.jsx)(NumberFieldWithState, {
        initialValue: initialValue,
        update: update,
        cellProps: cellProps
      }));
    }
  });
};
var _default = exports.default = NumberInputColumn;